import { Flex, Heading, Box, Text, Container } from '@chakra-ui/react'
import { FiAlertTriangle } from 'react-icons/fi'

const EmptyTableState = ({ title, message }: { title: string; message: string }) => {
    return (
        <Container maxW={'full'} my={12}>
            <Box textAlign="center" py={10} px={6}>
                <Box display="inline-block">
                    <Flex
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        bg={'gray.100'}
                        rounded={'50px'}
                        w={'55px'}
                        h={'55px'}
                        textAlign="center"
                    >
                        <FiAlertTriangle size={'30px'} color={'brand'} />
                    </Flex>
                </Box>
                <Heading as="h2" size="md" mt={6} mb={2}>
                    {title}
                </Heading>
                <Text color={'gray.500'}>{message}</Text>
            </Box>
        </Container>
    )
}

export default EmptyTableState
